module.exports = __webpack_public_path__ + "static/media/icon-checkup.93b8abb3.svg";